import { useSearchParams } from 'react-router-dom';
import { CheckEmailContent, CheckEmailError } from '@/components/auth/CheckEmailContent';
import { AuthMobileLayout, AuthDesktopLayout } from '@/components/auth/AuthLayouts';

function isValidContext(value: string | null): value is 'register' | 'reset' {
  return value === 'register' || value === 'reset';
}

export default function CheckEmailPage() {
  const [searchParams] = useSearchParams();
  const contextParam = searchParams.get('context');
  const email = searchParams.get('email');

  const isValid = isValidContext(contextParam) && email && email.trim().length > 0;

  const content = isValid ? (
    <CheckEmailContent context={contextParam} email={email} />
  ) : (
    <CheckEmailError />
  );

  return (
    <>
      <div className="block lg:hidden" data-testid="auth-mobile-section">
        <AuthMobileLayout>{content}</AuthMobileLayout>
      </div>
      <div className="hidden lg:block" data-testid="auth-desktop-section">
        <AuthDesktopLayout>{content}</AuthDesktopLayout>
      </div>
    </>
  );
}
